module.exports = __webpack_public_path__ + "static/media/purchasesSvg.ebf77d46.svg";